import { Stack, Text } from "@mantine/core";
import type { ReactNode } from "react";

import classes from "./EmptyState.module.css";

export interface EmptyStateProps {
  /** The illustration, up to 250px wide; an icon at 48px until one exists. */
  image?: ReactNode;
  title: string;
  description?: string;
  /** A button that gets the user out of the empty state, such as "Add Brand". */
  action?: ReactNode;
}

/** What a list says when it has nothing to show (design-system.md 3.5), fading in. */
export function EmptyState({ image, title, description, action }: EmptyStateProps) {
  return (
    <Stack align="center" justify="center" gap="xs" py="xl" className={classes.empty}>
      {image === undefined ? null : <div className={classes.image}>{image}</div>}
      <Text className={classes.title}>{title}</Text>
      {description === undefined ? null : (
        <Text className={classes.description}>{description}</Text>
      )}
      {action}
    </Stack>
  );
}
